import Link from "next/link";
import React from "react";

export default function Form() {
  return (
    <div className="overflow-x-auto max-w-7xl mx-auto bg-white">
      <h2 className="text-center my-8">Mandatory Public Disclosure</h2>
      <h6 className="text-left text-3xl mt-6">A:General Information</h6>
      <table className="max-w-7xl mx-auto bg-white">
        <thead>
          <tr>
            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              ID
            </th>
            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Information
            </th>
            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">1</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Name Of The School
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Bliss International School
            </td>
          </tr>
          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">2</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Affilication Number
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white"></td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">3</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              School Code
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white"></td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">4</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Complete Address With PinCode
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Bliss International School, Baroshiya , Urdauli Maholi Sitapur
              261141
            </td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">5</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Principal Name
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Gyanendra Pratap Singh Rathod
            </td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">6</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Principal Qualification
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              MA , B.Ed
            </td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">7</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              School Email Id
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              blissinternationalmaholi@gmail.com
            </td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">8</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Contact Details (Landline/Mobile)
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              +91-8381823050
            </td>
          </tr>
        </tbody>
      </table>

      <h6 className="text-left text-3xl mt-6">B: Documents and Information</h6>
      <table className="max-w-7xl mx-auto bg-white">
        <thead>
          <tr>
            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Sr.No
            </th>
            <th className="px-5 py-3  border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Documents / Information
            </th>

            <th className="px-5 py-3  border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              1
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF
              AFFILIATION, IF ANY
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              {/* <a className="bg-purple-500 text-white px-3 py-2 rounded-md" target="_blank" href="documents/affiliation.pdf">
                View Now
              </a> */}
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              2
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL
              CERTIFICATE, AS APPLICABLE
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                target="_blank"
                href="documents/trust-deed-updated.pdf"
              >
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              3
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY
              THE STATE GOVT./UT
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                href="documents/noc.pdf"
                target="_blank"
              >
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              4
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND IT’S
              RENEWAL IF APPLICABLE
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                href="documents/affiliation.pdf"
                target="_blank"
              >
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              5
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL
              BUILDING CODE
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
               <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                href="documents/BuildingSafety.pdf"
                target="_blank"
              >
                View Now
              </a> 
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              6
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT
              AUTHORITY
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                href="documents/fire-noc.pdf"
                target="_blank"
              >
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              7
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR
              AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATIONOR SELF
              CERTIFICATION BY SCHOOL
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a className="bg-purple-500 text-white px-3 py-2 rounded-md"
              href="documents/deo-certificate.pdf"
              target="_blank">
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              8
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                href="documents/water-and-sanitation.pdf"
                target="_blank"
              >
                View Now
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <h6 className="text-left text-3xl mt-6">C : RESULT AND ACADEMICS :</h6>
      <table className="max-w-7xl mx-auto bg-white">
        <thead>
          <tr>
            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Sr.No
            </th>
            <th className="px-5 py-3  border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Documents / Information
            </th>

            <th className="px-5 py-3  border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              1
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              FEE STRUCTURE OF THE SCHOOL
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                target="_blank"
                href="documents/fees.pdf"
              >
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              2
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              ANNUAL ACADEMIC CALANDER
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                target="_blank"
                href="documents/academic-calendar.pdf"
              >
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              3
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                target="_blank"
                href="documents/smc.pdf"
              >
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              4
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                target="_blank"
                href="documents/pta.pdf"
              >
                View Now
              </a>
            </td>
          </tr>

          <tr>
            <td className="px-5 w-[10px] py-2 border-b border-gray-200 bg-white">
              5
            </td>
            <td className="px-5 py-2 border-b capitalize border-gray-200 bg-white w-96">
              LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER
              APPLICABLILITY
            </td>
            <td className=" w-[24px] py-2 border-b border-gray-200 bg-white">
              {/* <a className="bg-purple-500 text-white px-3 py-2 rounded-md">
                View Now
              </a> */}
            </td>
          </tr>
        </tbody>
      </table>

      <h6 className="text-left text-3xl mt-6">D: STAFF (TEACHING) :</h6>
      <table className="max-w-7xl mx-auto bg-white">
        <thead>
          <tr>
            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              ID
            </th>
            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Information
            </th>
            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-lg font-semibold text-gray-600 uppercase tracking-wider">
              Details
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">1</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              PRINCIPAL
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">1</td>
          </tr>
          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">2</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              TOTAL NO. OF TEACHERS
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">22</td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white"></td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">PGT</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">0</td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white"></td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">TGT</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">5</td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white"></td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">PRT</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">14</td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">3</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              TEACHERS SECTION RATIO
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              1:1.5
            </td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">4</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              DETAILS OF SPECIAL EDUCATOR
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
             Maya Dubey
            </td>
          </tr>

          <tr>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">5</td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              DETAILS OF COUNSELLOR AND WELNESS TEACHER
            </td>
            <td className="px-5 py-2 border-b border-gray-200 bg-white">
              Mr. Prabhjeet Singh
            </td>
          </tr>
        </tbody>
      </table>

      <table cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td colspan="9" valign="middle">
              <p>
                <span>
                  <b>
                    <span className="Apple-converted-space">
                      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                    </span>
                    RESULT CLASS: XII
                  </b>
                </span>
              </p>
            </td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>
                  <b>S.NO.</b>
                </span>
              </p>
            </td>
            <td valign="middle">
              <p align="center">
                <span>
                  <b>YEAR</b>
                </span>
              </p>
            </td>
            <td colspan="3" valign="middle">
              <p align="center">
                <span>
                  <b>NO. OF REGISTERED STUDENTS</b>
                </span>
              </p>
            </td>
            <td colspan="3" valign="middle">
              <p align="center">
                <span>
                  <b>NO. OF STUDENTS PASSED</b>
                </span>
              </p>
            </td>
            <td colspan="3" valign="middle">
              <p align="center">
                <span>
                  <b>PASS PERCENTAGE</b>
                </span>
              </p>
            </td>
            <td valign="middle">
              <p align="center">
                <span>
                  <b>REMARKS</b>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td valign="bottom">&nbsp;</td>
          </tr>
          <tr>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td valign="bottom">&nbsp;</td>
          </tr>
          <tr>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
          </tr>
        </tbody>
      </table>

      <table cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td colspan="9" valign="middle">
              <p>
                <span>
                  <b>
                    <span className="Apple-converted-space">
                      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                    </span>
                    RESULT CLASS: X
                  </b>
                </span>
              </p>
            </td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>
                  <b>S.NO.</b>
                </span>
              </p>
            </td>
            <td valign="middle">
              <p align="center">
                <span>
                  <b>YEAR</b>
                </span>
              </p>
            </td>
            <td colspan="3" valign="middle">
              <p align="center">
                <span>
                  <b>NO. OF REGISTERED STUDENTS</b>
                </span>
              </p>
            </td>
            <td colspan="3" valign="middle">
              <p align="center">
                <span>
                  <b>NO. OF STUDENTS PASSED</b>
                </span>
              </p>
            </td>
            <td colspan="3" valign="middle">
              <p align="center">
                <span>
                  <b>PASS PERCENTAGE</b>
                </span>
              </p>
            </td>
            <td valign="middle">
              <p align="center">
                <span>
                  <b>REMARKS</b>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td valign="bottom">&nbsp;</td>
          </tr>
          <tr>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td colspan="3" valign="bottom">
              &nbsp;
            </td>
            <td valign="bottom">&nbsp;</td>
          </tr>
          <tr>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
            <td valign="bottom">&nbsp;</td>
          </tr>
        </tbody>
      </table>

      <table cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td colspan="9" valign="middle">
              <span>
                <b>
                  E{" "}
                  <span className="Apple-converted-space">
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{" "}
                  </span>
                </b>
                <u>
                  <b>SCHOOL INFRASTRUCTURE:</b>
                </u>
              </span>
            </td>
          </tr>
          <tr>
            <td valign="middle">
              <span>
                <b>SL NO.</b>
              </span>
            </td>
            <td colspan="4" valign="middle">
              <p align="center">
                <span>
                  <b>INFORMATION</b>
                </span>
              </p>
            </td>
            <td className="w-32" valign="middle">
              <p align="center">
                <span>
                  <b>DETAILS</b>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>1</span>
              </p>
            </td>
            <td colspan="4" valign="middle">
              <span>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)</span>
            </td>
            <td colspan="4" valign="middle">
              <p align="center">
                <span>
                  <span>8100 Sq/Mt</span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>2</span>
              </p>
            </td>
            <td colspan="4" valign="middle">
              <span>NO. AND SIZE OF THE CLASS ROOMS (IN SQ MTR)</span>
            </td>
            <td colspan="4" valign="middle">
              <p align="center">
                <span>
                  <span>24(50 Sq Mt)</span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>3</span>
              </p>
            </td>
            <td colspan="4" valign="middle">
              <span>
                NO AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN SQ MTR)
              </span>
            </td>
            <td colspan="4" valign="middle">
              <p align="center">
                <span>
                  <span>6 (56 Sq Mt)</span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>4</span>
              </p>
            </td>
            <td colspan="4" valign="middle">
              <span>INTERNET FACILITY (Y/N)</span>
            </td>
            <td colspan="4" valign="middle">
              <p align="center">
                <span>Y</span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>5</span>
              </p>
            </td>
            <td colspan="4" valign="middle">
              <span>NO. OF GIRLS TOILETS</span>
            </td>
            <td colspan="4" valign="middle">
              <p align="center">
                <span>
                  <span>15</span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>6</span>
              </p>
            </td>
            <td colspan="4" valign="middle">
              <span>NO. OF BOYS TOILETS</span>
            </td>
            <td colspan="4" valign="middle">
              <p align="center">
                <span>
                  <span>13</span>
                </span>
              </p>
            </td>
          </tr>
          <tr>
            <td valign="middle">
              <p align="center">
                <span>7</span>
              </p>
            </td>
            <td colspan="4" valign="middle">
              <span>
                LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL COVERING THE
                INFRASTRUCTURE OF THE SCHOOL
              </span>
            </td>
            <td class="w-[160px]" colspan="4" valign="middle">
              <a
                className="bg-purple-500 text-white px-3 py-2 rounded-md"
                target="_blank"
                href="https://www.youtube.com/watch?v=94eFFHdGYYw"
              >
                View Now
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
